import {io} from 'socket.io-client';

export const initSocket = async () =>{
    const options = {
        'force new connection': true,   // to create multiple room id
        reconnectionAttempts : 'Infinity',
        timeout: 10000,                 //millisecond
        transports: ['websocket'],
    };
    return io(process.env.REACT_APP_BACKEND_URL, options);
}